<template>
  <div class="q-pt-md">
    <q-stepper
      v-model="step"
      ref="stepper"
      contracted
      color="primary"
      animated
      inactive-icon="fiber_manual_record"
      active-icon="none"
      done-icon="none"
      :active-color="failed ? 'red-8' : 'primary'"
      flat
      class="q-stepper--step-progress"
    >
      <q-step
        v-for="v in numberOfSteps"
        :key="`step-indicator-${v}`"
        :name="v"
        title=""
        :done="step > v"
        class="q-py-none"
        :active-icon="(step === numberOfSteps) ? activeIcon : undefined"
      ></q-step>
    </q-stepper>
  </div>
</template>

<script>
export default {
  name: 'BaseStepProgress',
  props: {
    step: { default: 1 },
    failed: { type: Boolean, default: false },
    numberOfSteps: { default: 5 }
  },
  computed: {
    activeIcon () {
      return this.failed
        ? 'close'
        : 'check'
    }
  }
}
</script>
